import { ICrossRegionInfo, IResult } from "@/types/map";
import { loadModules } from "esri-loader";
import $ from "jquery";
import { checkPoints } from "../MapCenterCheck/arcgis/CheckPoints";

export default class CrossRegion {
  private static intances: Map<string, CrossRegion>;

  public static getInstance(view: __esri.SceneView) {
    const id = view.container.id;
    if (!CrossRegion.intances) {
      CrossRegion.intances = new Map();
    }
    let instance = CrossRegion.intances.get(id);
    if (!instance) {
      instance = new CrossRegion(view);
      CrossRegion.intances.set(id, instance);
    }
    return instance;
  }

  private initialized = false;

  private view: __esri.SceneView;
  private regionLayer!: __esri.GraphicsLayer;
  private drawLayer!: __esri.GraphicsLayer;
  private maskLayer!: __esri.GraphicsLayer;
  private geometryEngine!: __esri.geometryEngine;
  private webMercatorUtils!: __esri.webMercatorUtils;
  private Graphic!: __esri.GraphicConstructor;
  private Point!: __esri.PointConstructor;
  private Polyline!: __esri.PolylineConstructor;
  private Polygon!: __esri.PolygonConstructor;
  private SketchViewModel!: __esri.SketchViewModelConstructor;
  private regionMaskGraphic!: __esri.Graphic;
  private sketchVM!: __esri.SketchViewModel;

  private addedRegionGraphic: Array<__esri.Graphic> = [];

  private selectedCrosses: Array<string> = [];
  private normalCrossSymbol: __esri.Symbol = {
    type: "simple-marker",
    style: "circle",
    color: "#81c784",
    size: "12px",
    outline: {
      color: "white",
      width: 1,
    },
  } as any;
  private selectedCrossSymbol: __esri.Symbol = {
    type: "simple-marker",
    style: "circle",
    color: "red",
    size: "12px",
    outline: {
      color: "white",
      width: 1,
    },
  } as any;

  private allCrossGraphics: Array<__esri.Graphic> = [];
  private allRoadGraphics: Array<__esri.Graphic> = [];

  private readonly regionHeight = 0;
  private shanghaiExtent: __esri.Extent = {
    type: "extent",
    xmin: 121.123828,
    ymin: 30.854015,
    xmax: 122.008227,
    ymax: 31.400649,
    spatialReference: { wkid: 4326 },
  } as any;

  constructor(view: __esri.SceneView) {
    this.view = view;
  }

  private async initialize() {
    type MapModules = [
      typeof import("esri/Graphic"),
      typeof import("esri/geometry/Point"),
      typeof import("esri/geometry/Polyline"),
      typeof import("esri/geometry/Polygon"),
      typeof import("esri/geometry/geometryEngine"),
      typeof import("esri/geometry/support/webMercatorUtils"),
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/widgets/Sketch/SketchViewModel")
    ];
    const [
      Graphic,
      Point,
      Polyline,
      Polygon,
      geometryEngine,
      webMercatorUtils,
      GraphicsLayer,
      SketchViewModel,
    ] = await (loadModules([
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/geometry/Polyline",
      "esri/geometry/Polygon",
      "esri/geometry/geometryEngine",
      "esri/geometry/support/webMercatorUtils",
      "esri/layers/GraphicsLayer",
      "esri/widgets/Sketch/SketchViewModel",
    ]) as Promise<MapModules>);
    this.Graphic = Graphic;
    this.Point = Point;
    this.Polyline = Polyline;
    this.Polygon = Polygon;
    this.geometryEngine = geometryEngine;
    this.webMercatorUtils = webMercatorUtils;
    this.SketchViewModel = SketchViewModel;

    this.maskLayer = new GraphicsLayer();
    this.regionLayer = new GraphicsLayer();
    this.drawLayer = new GraphicsLayer();
    this.view.map.addMany([this.maskLayer, this.regionLayer, this.drawLayer]);

    // 获取所有路口点
    this.allCrossGraphics = checkPoints
      .filter((point) => point.type === "cross")
      .map((point) => {
        let crossPoint = new this.Point({
          x: point.position[0],
          y: point.position[1],
        });
        if (this.view.spatialReference.isWebMercator) {
          crossPoint = this.webMercatorUtils.geographicToWebMercator(
            crossPoint
          ) as __esri.Point;
        }
        const crossGraphic = new this.Graphic({
          geometry: crossPoint,
          attributes: {
            type: "cross",
            id: point.id,
            name: point.name,
          },
          symbol: this.normalCrossSymbol,
        });
        return crossGraphic;
      });

    // 获取所有道路
    // for (let layer of this.view.map.layers.toArray()) {
    //   if (layer.title === "道路") {
    //     const roadLayer = layer as __esri.FeatureLayer;
    //     this.allRoadGraphics = (await roadLayer.queryFeatures()).features;
    //   }
    // }

    this.initialized = true;
  }

  public async startDrawCrossRegion(params?: {
    tool?: string;
  }): Promise<IResult> {
    return new Promise<IResult>(async (resolve) => {
      if (!this.initialized) {
        await this.initialize();
      }

      this.drawLayer.addMany(this.allCrossGraphics);
      this.regionLayer.visible = false;
      this.maskLayer.visible = false;

      this.selectedCrosses = [];
      this.allCrossGraphics.forEach((crossGrahpic) => {
        crossGrahpic.symbol = this.normalCrossSymbol;
      });

      this.sketchVM = new this.SketchViewModel({
        view: this.view,
        layer: this.drawLayer,
        defaultCreateOptions: {
          hasZ: false,
        },
        polygonSymbol: {
          type: "simple-fill",
          color: [255, 249, 196, 0.5],
          outline: {
            color: "white",
            width: 2,
          },
        } as any,
      });

      const handle = this.sketchVM.on("create", (event) => {
        if (event.graphic && event.graphic.geometry.type === "polygon") {
          this.checkCrossContainsInRegion(event.graphic);
        }
        if (event.state === "complete") {
          handle.remove();
          this.sketchVM.destroy();

          let geometry = event.graphic.geometry;
          if (geometry.spatialReference.isWebMercator) {
            geometry = this.webMercatorUtils.webMercatorToGeographic(geometry);
          }

          this.addedRegionGraphic.push(event.graphic);
          const result = {
            border: (geometry as __esri.Polygon).rings[0],
            crosses: this.selectedCrosses,
          };

          this.regionLayer.visible = true;
          this.maskLayer.visible = true;
          resolve({
            status: 0,
            message: "",
            result,
          });
        }
      });

      let tool: "polygon" | "circle" | "rectangle" = "polygon";
      if (params && params.tool) {
        switch (params.tool) {
          case "polygon":
            tool = "polygon";
            break;
          case "rectangle":
            tool = "rectangle";
            break;
          case "circle":
            tool = "circle";
            break;
          default:
            tool = "polygon";
        }
      }
      this.sketchVM.create(tool);
    });
  }

  public stopDrawCrossRegion() {
    if (this.sketchVM) {
      this.sketchVM.destroy();
    }
  }

  private checkCrossContainsInRegion(regionGraphic: __esri.Graphic) {
    this.allCrossGraphics.forEach((crossGraphic) => {
      const crossId = crossGraphic.attributes["id"];
      const contains = this.geometryEngine.contains(
        regionGraphic.geometry,
        crossGraphic.geometry
      );
      if (contains && !this.selectedCrosses.includes(crossId)) {
        this.selectedCrosses.push(crossId);
        crossGraphic.symbol = this.selectedCrossSymbol;
      } else if (!contains) {
        const i = this.selectedCrosses.indexOf(crossId);
        if (i > -1) {
          this.selectedCrosses.splice(i, 1);
        }
        crossGraphic.symbol = this.normalCrossSymbol;
      }
    });
  }

  public async showCrossRegions(params: { regions: Array<ICrossRegionInfo> }) {
    if (!this.initialized) {
      await this.initialize();
    }

    // this.regionLayer.removeAll();
    this.drawLayer.removeAll();
    this.maskLayer.removeAll();

    const regions: Array<{ id: string; polygon: __esri.Polygon }> = [];
    const crosses: Array<{
      id: string;
      name: string;
      type: string;
      point: __esri.Point;
      regionId: string;
    }> = [];

    params.regions.forEach((regionInfo) => {
      if (regionInfo.border) {
        const ring = regionInfo.border;

        let polygon = new this.Polygon({
          rings: [ring],
          spatialReference: { wkid: 4326 },
        });
        regions.push({ id: regionInfo.id, polygon });
      }

      regionInfo.crosses.forEach((crossInfo) => {
        const { id, type } = crossInfo;
        const crossGraphic = this.allCrossGraphics.find(
          (graphc) => graphc.attributes["id"] === id
        );
        if (crossGraphic) {
          let point = crossGraphic.geometry.clone() as __esri.Point;
          crosses.push({
            id,
            name: crossGraphic.attributes["name"],
            type,
            point,
            regionId: regionInfo.id,
          });
        }
      });
    });

    // await this.view.goTo({ center: regions[0].polygon.centroid, scale: 10000 });
    await this.showRegionsAndCrosses(regions, crosses);
    // await this.animateRegionsAndCrosses(regions, crosses);
  }

  private async showRegionsAndCrosses(
    regions: Array<{ id: string; polygon: __esri.Polygon }>,
    crosses: Array<{
      id: string;
      name: string;
      type: string;
      point: __esri.Point;
      regionId: string;
    }>
  ) {
    const regionGraphics = regions.map((regionInfo) => {
      const regionPolygon = this.webMercatorUtils.geographicToWebMercator(
        regionInfo.polygon
      ) as __esri.Polygon;
      this.regionPolygons.set(regionInfo.id, regionPolygon);
      const regionGraphic = new this.Graphic({
        geometry: regionPolygon,
        symbol: {
          type: "simple-fill",
          color: [128, 222, 234, 0.7],
          style: "solid",
          outline: {
            type: "simple-line",
            style: "long-dash",
            color: "#00bcd4",
            width: 2,
          },
        } as any,
        attributes: { type: "region", regionId: regionInfo.id },
      });
      return regionGraphic;
    });
    this.regionLayer.addMany(regionGraphics);

    const crossGraphics = crosses.map((crossInfo) => {
      return new this.Graphic({
        geometry: crossInfo.point,
        symbol: {
          type: "point-3d",
          symbolLayers: [
            {
              type: "icon",
              size: "42px",
              resource: { href: `icon\\${crossInfo.type}-cross.png` },
            },
          ],
        } as any,
        attributes: {
          id: crossInfo.id,
          name: crossInfo.name,
          type: "region-cross",
          regionId: crossInfo.regionId,
        },
      });
    });
    this.regionLayer.addMany(crossGraphics);
    await this.view.goTo(crossGraphics);
  }

  private regionPolygons: Map<string, __esri.Polygon> = new Map();
  // private animateRegionsAndCrosses(
  //   regions: Array<{ id: string; polygon: __esri.Polygon }>,
  //   crosses: Array<{
  //     id: string;
  //     name: string;
  //     type: string;
  //     point: __esri.Point;
  //     regionId: string;
  //   }>
  // ): Promise<void> {
  //   return new Promise<void>((resolve) => {
  //     // 显示区域之外的遮罩
  //     let mask: __esri.Polygon = new this.Polygon({
  //       spatialReference: { wkid: 4326 },
  //     });
  //     const intersectRoadPolygons: Array<{
  //       id: string;
  //       polygon: __esri.Polygon;
  //     }> = [];

  //     const newRegionsPolygons: Array<{
  //       id: string;
  //       polygon: __esri.Polygon;
  //     }> = [];
  //     regions.forEach((regionInfo) => {
  //       let fullExtent: __esri.Geometry;
  //       if (this.regionMaskGraphic) {
  //         fullExtent = this.webMercatorUtils.webMercatorToGeographic(
  //           this.regionMaskGraphic.geometry
  //         );
  //       } else {
  //         fullExtent = this.shanghaiExtent;
  //       }
  //       mask = this.geometryEngine.difference(
  //         fullExtent,
  //         regionInfo.polygon
  //       ) as __esri.Polygon;

  //       const regionPolygon = this.webMercatorUtils.geographicToWebMercator(
  //         regionInfo.polygon
  //       ) as __esri.Polygon;
  //       this.regionPolygons.set(regionInfo.id, regionPolygon);
  //       newRegionsPolygons.push({ id: regionInfo.id, polygon: regionPolygon });

  //       intersectRoadPolygons.push({
  //         id: regionInfo.id,
  //         polygon: this.geometryEngine.intersect(
  //           this.allRoadGraphics[0].geometry,
  //           regionPolygon
  //         ) as __esri.Polygon,
  //       });
  //     });

  //     if (this.view.spatialReference.isWebMercator) {
  //       mask = this.webMercatorUtils.geographicToWebMercator(
  //         mask
  //       ) as __esri.Polygon;
  //     }
  //     this.regionMaskGraphic = new this.Graphic({
  //       geometry: mask,
  //       symbol: {
  //         type: "polygon-3d",
  //         symbolLayers: [
  //           {
  //             type: "fill",
  //             material: { color: [0, 0, 0, 0.7] },
  //           },
  //         ],
  //       } as any,
  //     });

  //     // 透明度动画
  //     let opacity = 0;
  //     this.maskLayer.opacity = opacity;
  //     this.maskLayer.add(this.regionMaskGraphic);
  //     requestAnimationFrame(() => {
  //       incrementOpacityByFrame();
  //     });
  //     const incrementOpacityByFrame = () => {
  //       opacity += 0.02;
  //       this.maskLayer.opacity = opacity;

  //       if (opacity < 1) {
  //         requestAnimationFrame(() => {
  //           incrementOpacityByFrame();
  //         });
  //       } else {
  //         requestAnimationFrame(() => {
  //           updateRegionAnimation();
  //         });
  //       }
  //     };

  //     // 区域polygon上升动画
  //     let currentRegionHeight = 0;
  //     let oldGraphics: Array<__esri.Graphic> = [];

  //     const fps = 30;
  //     const updateRegionAnimation = () => {
  //       setTimeout(() => {
  //         const newRegionGraphics: Array<__esri.Graphic> = [];
  //         newRegionsPolygons.forEach((polygonInfo) => {
  //           const { id, polygon } = polygonInfo;
  //           const newPolygon = polygon.clone();
  //           newPolygon.hasZ = true;
  //           const ring = newPolygon.rings[0];
  //           ring.forEach((point) => {
  //             point.push(currentRegionHeight);
  //           });
  //           const graphic = new this.Graphic({
  //             geometry: newPolygon,
  //             symbol: {
  //               type: "polygon-3d",
  //               symbolLayers: [
  //                 {
  //                   type: "fill",
  //                   material: { color: [128, 222, 234, 0.7] },
  //                   outline: {
  //                     color: "#00bcd4",
  //                     size: 2,
  //                   },
  //                 },
  //               ],
  //             } as any,
  //             attributes: {
  //               type: "region",
  //               regionId: id,
  //             },
  //           });
  //           newRegionGraphics.push(graphic);
  //         });

  //         const newRoadGraphics = intersectRoadPolygons.map((polygonInfo) => {
  //           const { id: regionId, polygon } = polygonInfo;

  //           const newRoadPolygon = polygon.clone();
  //           newRoadPolygon.hasZ = true;
  //           newRoadPolygon.rings.forEach((ring) => {
  //             ring.forEach((point) => {
  //               point.push(currentRegionHeight + 5);
  //             });
  //           });
  //           return new this.Graphic({
  //             geometry: newRoadPolygon,
  //             symbol: {
  //               type: "polygon-3d",
  //               symbolLayers: [
  //                 {
  //                   type: "fill",
  //                   material: { color: [63, 81, 181] },
  //                 },
  //               ],
  //             } as any,
  //             attributes: {
  //               regionId,
  //             },
  //           });
  //         });

  //         const newCrossGraphics = crosses.map((crossInfo) => {
  //           const newPoint = crossInfo.point.clone();
  //           newPoint.hasZ = true;
  //           newPoint.z = currentRegionHeight + 5;
  //           return new this.Graphic({
  //             geometry: newPoint,
  //             symbol: {
  //               type: "point-3d",
  //               symbolLayers: [
  //                 {
  //                   type: "icon",
  //                   size: "42px",
  //                   resource: { href: `icon\\${crossInfo.type}-cross.png` },
  //                 },
  //               ],
  //             } as any,
  //             attributes: {
  //               id: crossInfo.id,
  //               name: crossInfo.name,
  //               type: "region-cross",
  //               regionId: crossInfo.regionId,
  //             },
  //           });
  //         });

  //         const newGraphics = newRoadGraphics
  //           .concat(newRegionGraphics)
  //           .concat(newCrossGraphics);
  //         this.regionLayer.removeMany(oldGraphics);
  //         this.regionLayer.addMany(newGraphics);
  //         oldGraphics = newGraphics;

  //         currentRegionHeight += 5;

  //         if (currentRegionHeight < this.regionHeight) {
  //           requestAnimationFrame(() => {
  //             updateRegionAnimation();
  //           });
  //         } else {
  //           resolve();
  //         }
  //       }, 1000 / fps);
  //     };
  //   });
  // }

  public hideCrossRegions() {
    this.regionLayer.removeAll();
    this.drawLayer.removeAll();
    this.maskLayer.removeAll();
    if (this.sketchVM) {
      this.sketchVM.destroy();
    }
  }

  private deleteHandle: IHandle | undefined;
  public async startDeleteCrossRegion(): Promise<IResult> {
    return new Promise<IResult>(async (resolve) => {
      $(`#${this.view.container.id}`).css("cursor", "zoom-out");

      this.deleteHandle = this.view.on("click", async (event) => {
        const response = await this.view.hitTest(event, {
          include: [this.regionLayer],
        });

        const graphic = response.results[0]?.graphic;
        if (graphic?.attributes["type"] === "region") {
          const regionId = graphic.attributes["regionId"];
          this.regionPolygons.delete(regionId);

          // 删除相关区域的路口、道路、区域
          const removeGraphics = this.regionLayer.graphics.filter(
            (graphic) =>
              graphic.attributes && graphic.attributes["regionId"] === regionId
          );
          this.regionLayer.removeMany(removeGraphics.toArray());

          // 重新合成遮罩
          // let mask: __esri.Geometry = this.shanghaiExtent;
          // for (let polygon of this.regionPolygons.values()) {
          //   if (polygon.spatialReference.isWebMercator) {
          //     polygon = this.webMercatorUtils.webMercatorToGeographic(
          //       polygon
          //     ) as __esri.Polygon;
          //   }
          //   mask = this.geometryEngine.difference(
          //     mask,
          //     polygon
          //   ) as __esri.Geometry;
          // }
          // mask = this.webMercatorUtils.geographicToWebMercator(mask);
          // this.regionMaskGraphic.geometry = mask;

          $(`#${this.view.container.id}`).css("cursor", "default");
          if (this.deleteHandle) {
            this.deleteHandle.remove();
            this.deleteHandle = undefined;
          }

          resolve({
            status: 0,
            message: "",
            result: { id: regionId },
          });
        }
      });
    });
  }

  public stopDeleteCrossRegion() {
    $(`#${this.view.container.id}`).css("cursor", "default");
    if (this.deleteHandle) {
      this.deleteHandle.remove();
      this.deleteHandle = undefined;
    }
  }
}
